// Behind The Broadcast — partnerships video card player.
// Guarded so the section can be removed, duplicated or re-rendered in the
// theme editor without throwing.
(function () {
  function boot() {
    if (!document.getElementById('partnershipsVideo')) return;
  (function() {
    const video = document.getElementById('partnershipsVideo');
    const videoBg = document.querySelector('.partnerships-video-bg');
    const controlsBar = document.getElementById('videoControlsBar');
    const playedBar = document.getElementById('videoPlayed');
    const bufferedBar = document.getElementById('videoBuffered');
    const scrubHandle = document.getElementById('videoScrubHandle');
    const currentTimeEl = document.getElementById('videoCurrentTime');
    const durationEl = document.getElementById('videoDuration');
    const progressOuter = document.getElementById('videoProgressOuter');
    const card = document.getElementById('videoCard');

    let hideTimer = null;
    let isSeeking = false;

    function fmtTime(s) {
      if (!isFinite(s)) return '0:00';
      const m = Math.floor(s / 60);
      const sec = Math.floor(s % 60);
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    function showControls() {
      controlsBar.style.opacity = '1';
      controlsBar.style.pointerEvents = 'auto';
      scrubHandle.style.opacity = '1';
      clearTimeout(hideTimer);
    }

    function scheduleHide() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function() {
        if (!isSeeking) {
          controlsBar.style.opacity = '0';
          controlsBar.style.pointerEvents = 'none';
          scrubHandle.style.opacity = '0';
        }
      }, 2500);
    }

    card.addEventListener('mouseenter', function() { showControls(); });
    card.addEventListener('mousemove', function() { showControls(); scheduleHide(); });
    card.addEventListener('mouseleave', function() { scheduleHide(); });

    video.addEventListener('loadedmetadata', function() {
      durationEl.textContent = fmtTime(video.duration);
    });

    video.addEventListener('timeupdate', function() {
      if (isSeeking) return;
      const pct = video.duration ? (video.currentTime / video.duration) * 100 : 0;
      playedBar.style.width = pct + '%';
      scrubHandle.style.left = pct + '%';
      currentTimeEl.textContent = fmtTime(video.currentTime);
      // buffered
      if (video.buffered.length > 0) {
        const bPct = (video.buffered.end(video.buffered.length - 1) / video.duration) * 100;
        bufferedBar.style.width = bPct + '%';
      }
    });

    video.addEventListener('ended', function() {
      // Auto-replay: reset to beginning and play again
      video.currentTime = 0;
      if (videoBg) videoBg.currentTime = 0;
      video.play();
      if (videoBg) videoBg.play();
      // Keep pause icon showing (still playing)
      const playIcon = document.getElementById('playIconSvg');
      const pauseIcon = document.getElementById('pauseIconSvg');
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
      scheduleHide();
    });

    function getSeekPct(e) {
      const rect = progressOuter.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return Math.max(0, Math.min(1, x / rect.width));
    }

    function applySeek(pct) {
      const pctPx = pct * 100;
      playedBar.style.width = pctPx + '%';
      scrubHandle.style.left = pctPx + '%';
      currentTimeEl.textContent = fmtTime(pct * video.duration);
    }

    window.videoSeekStart = function(e) {
      e.preventDefault();
      isSeeking = true;
      showControls();
      const pct = getSeekPct(e);
      applySeek(pct);

      function onMove(ev) {
        const p = getSeekPct(ev);
        applySeek(p);
      }
      function onUp(ev) {
        const p = getSeekPct(ev);
        video.currentTime = p * video.duration;
        if (videoBg) videoBg.currentTime = video.currentTime;
        isSeeking = false;
        scheduleHide();
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onUp);
      }
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
      document.addEventListener('touchmove', onMove, { passive: true });
      document.addEventListener('touchend', onUp);
    };

    progressOuter.addEventListener('touchstart', function(e) {
      window.videoSeekStart(e.touches[0]);
    }, { passive: true });
  })();

  // The card and the two overlay buttons call these from inline onclick
  // attributes, which resolve against the GLOBAL scope. Declared only inside
  // boot() they were unreachable, so clicking the card or the buttons threw a
  // ReferenceError and the video could neither be paused nor unmuted — while
  // seeking worked, because window.videoSeekStart above is exported. Export
  // these the same way.
  function togglePlayPause(card) {
    const video = document.getElementById('partnershipsVideo');
    const videoBg = document.querySelector('.partnerships-video-bg');
    const playIcon = document.getElementById('playIconSvg');
    const pauseIcon = document.getElementById('pauseIconSvg');
    const bigPlay = document.getElementById('videoBigPlay');
    if (video.paused) {
      video.play();
      if (videoBg) videoBg.play();
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
      if (bigPlay) bigPlay.style.display = 'none';
    } else {
      video.pause();
      if (videoBg) videoBg.pause();
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      if (bigPlay) bigPlay.style.display = 'flex';
    }
  }

  function togglePlayPauseFromBtn() {
    const video = document.getElementById('partnershipsVideo');
    const videoBg = document.querySelector('.partnerships-video-bg');
    const playIcon = document.getElementById('playIconSvg');
    const pauseIcon = document.getElementById('pauseIconSvg');
    const bigPlay = document.getElementById('videoBigPlay');
    if (video.paused) {
      video.play();
      if (videoBg) videoBg.play();
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
      if (bigPlay) bigPlay.style.display = 'none';
    } else {
      video.pause();
      if (videoBg) videoBg.pause();
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      if (bigPlay) bigPlay.style.display = 'flex';
    }
  }

  function toggleSound() {
    const video = document.getElementById('partnershipsVideo');
    const soundMuted = document.getElementById('soundMutedSvg');
    const soundPlaying = document.getElementById('soundPlayingSvg');
    if (video.muted) {
      video.muted = false;
      soundMuted.style.display = 'none';
      soundPlaying.style.display = 'block';
    } else {
      video.muted = true;
      soundMuted.style.display = 'block';
      soundPlaying.style.display = 'none';
    }
  }
    window.togglePlayPause = togglePlayPause;
    window.togglePlayPauseFromBtn = togglePlayPauseFromBtn;
    window.toggleSound = toggleSound;
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  // boot() bails unless #partnershipsVideo exists, so a late script is safe to
  // run immediately when the DOM is already parsed.
  if (document.readyState !== 'loading') boot();
})();
